
import { BackupServerDto } from '@/services/Backup/interfaces/index';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { NonEmptyString } from '@/services/FtpUser/validators/string';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class EditBackupServerDialog extends Vue {
  public visible: boolean = true;

  @Prop()
  public readonly backupServer!: BackupServerDto;

  public name: string = this.backupServer.serverName;
  public nameRules = [NonEmptyString("Name is required")];

  public saveChanges(): void {
    this.backupServer.serverName = this.name;
    this.$emit('edit', this.backupServer);
  }

  public destroyComponent(): void {
    this.$emit('close');
  }
}
